export const setTheme = (theme) => {
  if (theme === "auto") {
    localStorage.removeItem("theme");
    themeTime();
  } else {
    localStorage.setItem("theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }
};

export const themeTime = () => {
  const currentHour = new Date().getHours();
  let theme;

  if (currentHour >= 6 && currentHour < 19) {
    theme = "day";
    // console.log("Day");
  } else {
    theme = "dark";
    // console.log("Night");
  }
  document.documentElement.setAttribute("data-theme", theme);
  return theme;
};

// Chiamare questa funzione una volta all'avvio per impostare il tema iniziale
export const initializeTheme = () => {
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme) {
    document.documentElement.setAttribute("data-theme", savedTheme);
  } else {
    themeTime();
  }
};

//Esempio funzione per stampare l'ora in console e come esportare una funzione d
// da usare in un'altra pagina (FUNZIONE NON PASSATA A NESSUNA PAGINA)
export const oraLocale = () => {
  const currentTime = new Date().toLocaleString();
  console.log("ora Locale:", currentTime);
};
